import React, { useState } from 'react';
import contenu from '../contenu';

const faqs = contenu.faq;

const FAQ = () => {
  const [open, setOpen] = useState(null);

  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-gold font-medium mb-2">Vous avez des questions ?</p>
          <h2 className="text-4xl font-bold text-charcoal mb-4">Questions Fréquentes</h2>
          <div className="w-16 h-1 bg-gold mx-auto"></div>
        </div>
        <div className="flex flex-col gap-4">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-charcoal/10 rounded-xl overflow-hidden">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex justify-between items-center px-6 py-5 text-left bg-white hover:bg-stone-50 transition-colors"
              >
                <span className="font-medium text-charcoal">{faq.question}</span>
                <span className="text-gold text-2xl ml-4">{open === i ? '−' : '+'}</span>
              </button>
              {open === i && (
                <div className="px-6 py-4 bg-stone-50 text-charcoal/70 leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
